import LinkButton from "../buttons/button/LinkButton";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useProduct } from "../../context/product/ProductContext";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import getMembersDayTranslations from "./getMembersDayTranslations";
import getCtaUrl from "./getCtaUrl";
import styles from "./MembersDayBox.scss";
import { getMembersDayContext } from "../../utils/loyalty/getMembersDayContext";
import { APP_MEMBERS_SALE_LIVE } from "../../constants";
import { useEffect, useState } from "react";
import setMembersDayTracking from "../../analytics/pageLoad/membersDay";

const MembersDayBox = () => {
  const { getTranslation, webContext, isMobile } = useRuntimeConstants();
  const { product } = useProduct();
  const [membersDayContext, setMembersDayContext] = useState(null);
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (!product) return;

    const fetchMembersDayContext = async () => {
      const { membersDayContext, startDate, analyticsProps } =
        await getMembersDayContext(product);
      setMembersDayContext(membersDayContext);
      setStartDate(startDate);
      if (membersDayContext) {
        setMembersDayTracking(analyticsProps);
      }
    };

    fetchMembersDayContext();
  }, [product]);

  if (!product || !membersDayContext) {
    return null;
  }

  const isMembersDay = membersDayContext.context === APP_MEMBERS_SALE_LIVE;
  const { priceBanner, copy, dateSubtitle, buttonText } =
    getMembersDayTranslations(getTranslation, startDate, isMembersDay);

  const ctaUrl = getCtaUrl({ isMobile, webContext, product });

  return (
    <div className={styles.membersDayBox}>
      <div className={styles.membersDayBoxHeader}>
        <div className={styles.membersPrice}>
          {isMembersDay ? (
            <span className={styles.membersPriceText}>
              {membersDayContext.current.text}
            </span>
          ) : (
            <span className={styles.membersPriceBanner}>{priceBanner}</span>
          )}
          <div className={styles.membersPriceTag}>
            <div className="product-members-price-tag" />
            {isMembersDay && (
              <span>{`-${membersDayContext.discountPercentage}%`}</span>
            )}
          </div>
        </div>
        <div className={styles.asosWorldLogo}>
          <div className="product-asos-world" />
        </div>
      </div>
      <p className={styles.description}>
        <span>{copy}</span>
      </p>
      <p className={styles.date}>{dateSubtitle}</p>
      <LinkButton
        href={ctaUrl}
        type={BUTTON_TYPES.loyaltyFullWidth}
        ariaLabel={buttonText}
        additionalClasses={styles.button}
      >
        <div className={styles.buttonText}>{buttonText}</div>
      </LinkButton>
    </div>
  );
};

export default MembersDayBox;
